import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { modulesListReducer } from './reducers/modulesList';
import { viewReducer } from './reducers/view';
import { loginReducer } from './reducers/login';
import { savedVersionsReducer } from './reducers/savedVersions';
import { userReportReducer } from './reducers/userReport';
import { userOverallReportReducer } from './reducers/userOverallReport';
import { messagesListReducer } from './reducers/messagesList';
import { messageContentReducer } from './reducers/messageContent';
import { messageDeleteReducer } from './reducers/messageDelete';
import { addProgramReducer } from './reducers/addProjectCode';
import { addUserReducer } from './reducers/addUser';
import { deleteUserReducer } from './reducers/deleteUser';
import { addTeamLeaderReducer } from './reducers/addTeamLeader';
import { connectedUsersReducer } from './reducers/connectedUsers';
import { messageReducer } from './reducers/message';
import { teamMembersReducer } from './reducers/teamMembers';
import { teamMembersFullReducer } from './reducers/teamMembersFull';
import { userProgramsFullReducer } from './reducers/userProgramsFull';
import { xapiReducer } from './reducers/xapi';
import { addComponentStatus } from './reducers/addComponentStatus';
import { tutorialReducer } from './reducers/tutorial';
import { dropdownsReducer } from './reducers/dropdowns';
import { checkCodeReducer } from './reducers/checkProjectCode';
import { assignmentRequest } from './reducers/assignmentRequest';
import { DeactivateReducer } from './reducers/deactivate';
import { announcementsReducer } from './reducers/announcements';
import { annotationsReducer } from './reducers/annotations';
import { systemReducer } from './reducers/system';
import { updateProfile } from './reducers/updateProfile';
import { userRatingReducer } from './reducers/userRatings';
import {versionStatusReducer} from './reducers/versionStatus';
import {PWAReducer} from './reducers/updatePWA'
import {checkInternetReducer} from './reducers/checkInternet'
import {contentListReducer} from './reducers/contentList';
import {popiReducer} from './reducers/popi'
import {turnitinReducer} from './reducers/turnitin'


const makeRootReducer = asyncReducers =>
  combineReducers({
    form: formReducer,
    viewReducer,
    loginReducer,
    savedVersionsReducer,
    userReportReducer,
    userOverallReportReducer,
    modulesListReducer,
    messagesListReducer,
    messageContentReducer,
    messageDeleteReducer,
    addProgramReducer,
    addUserReducer,
    deleteUserReducer,
    addTeamLeaderReducer,
    connectedUsersReducer,
    messageReducer,
    teamMembersReducer,
    teamMembersFullReducer,
    userProgramsFullReducer,
    xapiReducer,
    addComponentStatus,
    tutorialReducer,
    dropdownsReducer,
    checkCodeReducer,
    assignmentRequest,
    DeactivateReducer,
    announcementsReducer,
    annotationsReducer,
    systemReducer,
    updateProfile,
    userRatingReducer,
    versionStatusReducer,
    PWAReducer,
    checkInternetReducer,
    contentListReducer,
    popiReducer,
    turnitinReducer,
    assignmentRequest,
    ...asyncReducers,
  });

export const injectReducer = (store, { key, reducer }) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return;

  store.asyncReducers[key] = reducer;
  store.replaceReducer(makeRootReducer(store.asyncReducers));
};

export default makeRootReducer;
